import { Clock as ClockIcon } from "@/assets/icons/24/Clock";
import { SearchBox } from "@/features/search/components/search-box/SearchBox";
import { useSearchBoxContext } from "@/features/search/components/search-box/search-box.context";
import { useRecentSearches } from "@/features/search/hooks/useRecentSearches";

/**
 * The visitor's own recent searches, from this device. Only while the field is empty — once they
 * start typing, suggestions for what they are typing are the more useful list.
 */
export const SearchBoxRecents = () => {
  const { term } = useSearchBoxContext();
  const { recentTerms } = useRecentSearches();

  if (term.trim()) {
    return null;
  }

  return (
    <>
      {recentTerms.map(recentTerm => (
        <SearchBox.Item
          key={recentTerm}
          value={`recent:${recentTerm}`}
          term={recentTerm}
          icon={<ClockIcon className="size-5" />}
        />
      ))}
    </>
  );
};
